import { render, staticRenderFns } from "./AppParcelsComponent.vue?vue&type=template&id=a7761736&scoped=true&"
import script from "./AppParcelsComponent.vue?vue&type=script&lang=js&"
export * from "./AppParcelsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7761736",
  null
  
)

export default component.exports